import { PARAM_CHANGE } from '@store/actions';
import BLOCKS from '@store/blocks';
import testingAPI from '@utils/testingGUIAPI';

export function COORDS_CHANGE(store, pos) {
  PARAM_CHANGE(store, BLOCKS.MAP.CURSOR_POSITION, pos);
}

export function CROSSHAIR_MOVE(store, pos) {
  if (store.get(BLOCKS.MAP.CROSSHAIR_SETTING) > -1) {
    PARAM_CHANGE(store, BLOCKS.MAP.PICKING_MARKER, pos);
  }
}

export function CROSSHAIR_SETUP(store, coords) {
  if (store.get(BLOCKS.MAP.CROSSHAIR_SETTING) > -1) {
    const activeMarker = store.get(BLOCKS.MAP.ACTIVE_MARKERS);
    let markers = [activeMarker[0], activeMarker[1]];

    markers[store.get(BLOCKS.MAP.CROSSHAIR_SETTING)] = coords;
    PARAM_CHANGE(store, BLOCKS.MAP.ACTIVE_MARKERS, markers);
    if (store.get(BLOCKS.MAP.CROSSHAIR_SETTING) === 0) {
      testingAPI.onStartingPointSelect(markers[0].x, markers[0].y);
    } else {
      testingAPI.onEndingPointSelect(markers[1].x, markers[1].y);
    }
    CROSSHAIR_CANCEL(store);
  }
}

export function CROSSHAIR_CANCEL(store) {
  PARAM_CHANGE(store, BLOCKS.MAP.CROSSHAIR_SETTING, -1);
}

export function AUGMENT_MARKS(store, count) {
  PARAM_CHANGE(store, BLOCKS.MAP.MARKER_COUNT, count);
}
